import React from 'react';

import { EnterpriseHero } from 'components/Hero';
import { HeroSectionType } from 'utils/types';

export interface HeroContainerProps {
  content: HeroSectionType;
}

export const HeroContainer: React.FC<HeroContainerProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  const {
    headline,
    backgroundColor,
    desktopImage,
    mobileImage,
    mainCta,
  } = content;

  return (
    <EnterpriseHero
      headline={headline}
      mainCta={mainCta}
      backgroundColor={backgroundColor}
      backgroundImage={desktopImage.fluid}
      mobileBackgroundImage={mobileImage.fluid}
    />
  );
};

export default HeroContainer;
